"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("@pds-react/icon"));

var _excluded = ["header", "active", "href", "type", "eyebrow", "as", "className", "spacing", "children", "divider", "backgroundColor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardSection = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var header = props.header,
      active = props.active,
      href = props.href,
      type = props.type,
      eyebrow = props.eyebrow,
      as = props.as,
      className = props.className,
      spacing = props.spacing,
      children = props.children,
      divider = props.divider,
      backgroundColor = props.backgroundColor,
      otherProps = _objectWithoutProperties(props, _excluded);

  var classes = (0, _classnames["default"])(className, "pds-card-section", _defineProperty({}, "pds-card-section-".concat(type), type), {
    "pds-card-top-divider": divider === "top",
    "pds-card-bottom-divider": divider === "bottom"
  }, {
    "pds-card-bg-primary-blue-2": backgroundColor === "primary-blue-2"
  });
  var Component = as;
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: classes,
    ref: ref
  }, otherProps), active ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, eyebrow && /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-typography-eyebrow-".concat(spacing === "condensed" ? "2" : "1")
  }, eyebrow), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _react["default"].Children.toArray(children).map(function (child) {
    // eslint-disable-next-line max-statements-per-line
    if (child.type.displayName === "CardTitle") {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        active: active,
        href: href
      });
    }

    return child;
  }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: "arrow-right",
    size: 20
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, eyebrow ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-typography-line-break-text pds-typography-eyebrow-1"
  }, /*#__PURE__*/_react["default"].createElement("span", null, eyebrow)) : "", _react["default"].Children.toArray(children).map(function (child) {
    // eslint-disable-next-line max-statements-per-line
    if (child.type.displayName === "CardTitle") {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        header: header
      });
    }

    return child;
  })));
});

CardSection.propTypes = {
  /** Card sections for active cards. */
  active: _propTypes["default"].bool,

  /** Adds an eyebrow label to the top of the CardSection. */
  eyebrow: _propTypes["default"].string,

  /** Adds a divider line to the top or bottom of the CardSection. */
  divider: _propTypes["default"].oneOf(["top", "bottom"]),

  /** Styles the background color of the CardSection */
  backgroundColor: _propTypes["default"].oneOf(["primary-blue-2"]),

  /** Changes the HTML element of the CardSection. */
  as: _propTypes["default"].elementType,

  /** Extra classes for the CardSection. */
  className: _propTypes["default"].string,

  /** Controls the spacing (i.e. padding) inside of the card.  */
  spacing: _propTypes["default"].oneOf(["condensed"]),

  /** The content of the CardSection. */
  children: _propTypes["default"].node,

  /** Where the callout card will navigate to. */
  href: _propTypes["default"].string,

  /** Type of section */
  type: _propTypes["default"].oneOf(["body", "support", "ctas"]),

  /** Header forwarded from card */
  header: _propTypes["default"].oneOf(["header", "header-alt"])
};
CardSection.defaultProps = {
  as: "div"
};
CardSection.displayName = "CardSection";
var _default = CardSection;
exports["default"] = _default;